document.addEventListener('DOMContentLoaded', () => {

  const mainSwiper = new Swiper('.ugc-video-swiper', {
    slidesPerView: 5,
    spaceBetween: 24,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    breakpoints: {
      0: { slidesPerView: 2 },
      768: { slidesPerView: 3 },
      1024: { slidesPerView: 5 }
    }
  });

  const modal = document.querySelector('.ugc-modal');
  const closeBtn = document.querySelector('.ugc-close');
  const backdrop = document.querySelector('.ugc-modal-backdrop');

  const slides = document.querySelectorAll('.ugc-video-item');
  let currentIndex = 0;

  slides.forEach((slide) => {

    slide.addEventListener('click', function () {

        currentIndex = parseInt(this.getAttribute('data-index'));
        const videoSrc = this.querySelector('video')
            ? this.querySelector('video').src
            : this.dataset.video;
        const productName = this.dataset.productName;
        const productPrice = this.dataset.productPrice;
        const productImage = this.dataset.productImage;
        const productUrl = this.dataset.productUrl;
        openPopup();
        loadSlideData(currentIndex, videoSrc, productName, productPrice, productImage, productUrl);
    });

  });



  function loadSlideData(index, videoSrc=null, productName=null, productPrice=null, productImage=null, productUrl=null) {

    let slide;
    if(!(videoSrc && productName && productPrice && productImage && productUrl)){
        slide = document.querySelectorAll('.ugc-video-item:not(.swiper-slide-duplicate)')[index];
        videoSrc = slide.querySelector('video')
            ? slide.querySelector('video').src
            : slide.querySelector('.ugc-video-poster')?.dataset.videoSrc;
        productName = slide.dataset.productName;
        productPrice = slide.dataset.productPrice;
        productImage = slide.dataset.productImage;
        productUrl = slide.dataset.productUrl;
    }
    const popupSlide = document.querySelector('.ugc-popup-slide');
    const videoContainer = popupSlide.querySelector('.ugc-popup-video-container');

    videoContainer.innerHTML = '';

    if (videoSrc) {
      const video = document.createElement('video');
      video.src = videoSrc;
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      video.style.width = "100%";

      videoContainer.appendChild(video);
    }

    popupSlide.querySelector('.prod_title').textContent = productName || '';
    popupSlide.querySelector('strong').textContent = productPrice || '';
    popupSlide.querySelector('.ugc-popup-product img').src = productImage || '';
    popupSlide.querySelector('.ugc-buy').href = productUrl || '#';
  }

  function openPopup() {
    modal.classList.remove('hidden');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ugc-lock');
  }

  function closePopup() {
    modal.classList.add('hidden');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ugc-lock');

    document.querySelector('.ugc-popup-video-container').innerHTML = '';
  }

  closeBtn.addEventListener('click', closePopup);
  backdrop.addEventListener('click', closePopup);

  /* NEXT / PREV BUTTONS */

  document.querySelector('.ugc-popup-next').addEventListener('click', () => {
    currentIndex = (currentIndex + 1) % slides.length;
    loadSlideData(currentIndex);
  });

  document.querySelector('.ugc-popup-prev').addEventListener('click', () => {
    currentIndex = (currentIndex - 1 + slides.length) % slides.length;
    loadSlideData(currentIndex);
  });

});

function replacePostersWithVideos() {
  document.querySelectorAll('.ugc-video-poster').forEach(poster => {

    const src = poster.dataset.videoSrc;
    if (!src) return;

    const video = document.createElement('video');
    video.src = src;
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.autoplay = true;
    video.style.width = "100%";
    video.style.height = "100%";
    video.style.objectFit = "cover";

    poster.replaceWith(video);
  });
}

window.addEventListener('load', replacePostersWithVideos);

document.querySelectorAll('.ugc-product').forEach(product => {
  product.addEventListener('click', function (e) {
    e.stopPropagation();
  });
});
